export const ITEM_HEIGHT = 36;
export const ROW_PADDING_LEFT = 16;
export const CHECKBOX_WIDTH = 32;
export const CHEVRON_SIZE = 24;
export const LEVEL_INDENT_BASE = 24;
export const LEVEL_INDENT_INCREMENT = 32;
export const CLICK_DELAY = 200;
export const GROUPED_NAME_PATTERN = /^(.+)\s+\(?\d+\)?$/;
